import { useStoreSelector } from '../../../../../core/store/selector.js';
import { MeterBarChartTooltipContext } from '../../context/MeterBarChartTooltipContext.js';
import { MeterBarChartTooltipState } from '../../types/state.js';

export const useSelector = <T>(
  selector: (state: MeterBarChartTooltipState) => T,
): T => useStoreSelector(MeterBarChartTooltipContext, selector);
